import { Button } from '@mui/material';
import { t } from '@ankr.com/common';
import { MouseEvent, useCallback } from 'react';

import { resetRedirectURL } from 'modules/auth/store/authSlice';
import { useAppDispatch } from 'store/useAppDispatch';
import { useSSOAuth } from 'modules/auth/hooks/useSSOAuth';
import { waitForLocalStorageSync } from 'modules/common/utils/waitForLocalStorageSync';

export interface ISignInButtonProps {
  children?: string;
}

export const SignInButton = ({
  children = t('header.wallet-button'),
}: ISignInButtonProps) => {
  const { handleSignIn, signInUrl } = useSSOAuth();

  const dispatch = useAppDispatch();

  const onClick = useCallback(
    async (event: MouseEvent<HTMLAnchorElement>) => {
      event.preventDefault();
      dispatch(resetRedirectURL());

      await waitForLocalStorageSync();

      handleSignIn();
    },
    [dispatch, handleSignIn],
  );

  return (
    <Button
      component="a"
      href={signInUrl.toString()}
      color="primary"
      onClick={onClick}
      variant="contained"
    >
      {children}
    </Button>
  );
};
